import { Form } from 'formik';
import styled from 'styled-components';

export const SignInContentContainerStyled = styled.div`
  padding: 35px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const FormStyled = styled(Form)`
  justify-content: center;
  align-items: center;
`;

export const ActionButtonContainer = styled.div<{ marginTop?: string }>`
  margin-top: ${({ marginTop }) => marginTop || '-15px'};
`;

export const ForgotPasswordContainerStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
`;

export const OrTextContainerStyled = styled.span`
  margin-right: 10px;
`;
